import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localtimezone'
})
export class LocaltimezonePipe extends
  DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    const newValue = new Date(value);
    const localDateTime = new Date(newValue.getTime() - newValue.getTimezoneOffset() * 60000); // Convert to local timezone
    let latestDatetime = localDateTime.toISOString();
    if (args != undefined && args == 'sec') {
      return super.transform(latestDatetime, 'MM/dd/yyyy hh:mm:ss a');
    } else {
      return super.transform(latestDatetime, 'MM/dd/yyyy hh:mm a');
    }

  }
}
